module.exports = __webpack_public_path__ + "img/croc.296055c7.png";